import React, { useEffect } from 'react';
import navTitle from './navTitle';
import Downloads from '../../containers/downloads';
import TPA_MedicalScheduling from '../../containers/TPA_MedicalScheduling';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import ProposalDashboard from '../../containers/dashboard/ProposalDashboard';
import FileUpload from '../FileUpload';
import Operations from '../../containers/operations';
import CreateApp from '../../components/CreateApp';
import ProposalDetails from '../../containers/proposals';
import { hasPermission } from '../Permissions';
import { availability } from '../Availablity';
import InstaVerify from '../../containers/instaVerify';
import Logs from '../../containers/logs';
import SwitchApi from '../../containers/switchAPI';
import PaymentPatching from '../../containers/PaymentPatching';
import CibilReports from "../../containers/cibilReport"
import Reports from "../../containers/ckycekycReport"
import SMSandEMAILlogs from "../../containers/ccmSMSandEMAILlogs";
import DisableProposal from "../../containers/disableProposal";
import EnableDisableProposal from '../../containers/enableDisableProposal';
import DisableEnableProposal from "../../containers/disableEnableProposal"
import ProductConfig from "../../containers/Product-Configuration";
import D2cPayment from "../../containers/d2cPayment";
import Insta2 from "../../containers/insta2";
import InstaVerifyList from '../../containers/instaVerifyList';
import OldInstaVerifyList from '../../containers/instaVerifyList/oldInstaVerifyList';
import UatInstaVerifyList from '../../containers/instaVerifyList/uatInstaVerifyList';
import ProposalDetailsComp from "../NewProposalDetails/index"
import Report from "../../containers/AllReports/index"
import { useSelector } from "react-redux";
import OldProposalDashboard from "../../containers/dashboard/oldProposalDashboard";
import MonthEnd from "../../containers/MonthEndConfig/index";
import FtProcess from "../../containers/ftProcess";
import BlueChip from '../../containers/blueChip';
import Untagged from '../../containers/untagged';
import UpfrontPayment from '../../containers/UpfrontPayment';
import Settings from "../../containers/Settings";
import UpfrontPaymentReport from '../../containers/UpfrontPaymentReport';


const SubHeader = (props) => {
    const { user, loader } = useSelector((state) => {
        return {
            user: state.authentication,
            loader: state.loader.loader
        }
    });
    useEffect(() => {
        if (props.showProposal && props.proposalData) {
        }
    }, [props.proposalData])

    const handleChange = (val) => {
        props.setProposalTab(val)
    }

    const nav = (iconClass, label) => navTitle(iconClass, label, !props.showMenu);

    return (
        <div className={`data-container ops-layout ${props.showMenu ? 'showBar' : ''}`}>
            <Tabs mountOnEnter={true} unmountOnExit={true}
                // defaultActiveKey={hasPermission("D2C_OFFLINE") ? "D2Cpayment" : "proposal"}
                activeKey={props.proposalTab}
                onSelect={handleChange}
                id="uncontrolled-tab-example"
                className="ops-sidebar-tabs"
            >
                {/* {hasPermission('PROPOSAL_DETAILS') && <Tab eventKey="proposal" title="Proposal Details">
                <ProposalDetails />
            </Tab>} */}
                {props.showProposal && Object?.values(props.proposalData)?.length > 0 && hasPermission('PROPOSAL_DETAILS') &&
                    <Tab
                        eventKey="proposal"
                    //  title="Proposal Details"
                    >
                        {loader && <div id="cover-spin"></div>}
                        <ProposalDetailsComp proposalData={props.proposalData} proposalNumber={props.proposalNumber} />
                    </Tab>
                }
                {!hasPermission('D2C_OFFLINE') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="Dashboard" title={nav('fa-th-large', 'Dashboard')}>
                    {loader && <div id="cover-spin"></div>}
                    <ProposalDashboard />
                </Tab>}
                {/* {(user.envType==="PROD") &&
                !hasPermission('D2C_OFFLINE') && <Tab eventKey="Dashboard" title="Dashboard">
                <OldProposalDashboard />
            </Tab>} */}

                {
                    // !hasPermission('D2C_OFFLINE') &&
                    !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') &&
                    <Tab eventKey="tpa" title={nav('fa-calendar', 'TPA Medical Scheduling')}>
                        {window.envType === "DEV" && loader && <div id="cover-spin"></div>}
                        <TPA_MedicalScheduling
                            proposalNumber={props.proposalNumber}
                        />
                    </Tab>}


                {hasPermission('DOWNLOADS') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="Reports" title={nav('fa-file-text-o', 'Reports')}>
                    {window.envType === "DEV" && loader && <div id="cover-spin"></div>}
                    <Report />
                </Tab>}

                {hasPermission('DOWNLOADS') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="Downloads" title={nav('fa-download', 'Downloads')}>
                    {loader && <div id="cover-spin"></div>}
                    <Downloads />
                </Tab>}
                {hasPermission('OPERATIONS') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="Operations" title={nav('fa-cog', 'Operations')}>
                    {loader && <div id="cover-spin"></div>}
                    <Operations />
                </Tab>}
                {hasPermission('FILE_UPLOAD') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="FileUpload" title={nav('fa-upload', 'File Upload')}>
                    {loader && <div id="cover-spin"></div>}
                    <FileUpload />
                </Tab>}
                {hasPermission('CREATE_APP') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="Create App" title={nav('fa-plus-circle', 'Create App')}>
                    {loader && <div id="cover-spin"></div>}
                    <CreateApp />
                </Tab>}
                {/* {hasPermission('LOGS_DETAILS') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="logs" title={nav('fa-plug', 'API Integration Logs')}>
                    {loader && <div id="cover-spin"></div>}
                    <Logs />
                </Tab>} */}
                {/* {hasPermission('INSTAVERIFY_DETAILS') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && availability('INSTAVERIFY_DETAILS') && <Tab eventKey="InstaVerify" title={nav('fa-shield', 'Insta Verify')}>
                    {loader && <div id="cover-spin"></div>}
                    <InstaVerify />
                </Tab>} */}
                {hasPermission('SWITCH_API') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="switchAPI" title={nav('fa-toggle-on', 'Proposal Submission Switch')}>
                    {loader && <div id="cover-spin"></div>}
                    <SwitchApi />
                </Tab>}
                {hasPermission('PAYMENTS') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="payments" title={nav('fa-credit-card', 'Payments')}>
                    {loader && <div id="cover-spin"></div>}
                    <PaymentPatching />
                </Tab>}
                {/* {hasPermission('REPORTS') && <Tab eventKey="reports" title="Ekyc_Ckyc Reports">
                <Reports/>
            </Tab>} */}
                {/* {!hasPermission('D2C_OFFLINE') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="reports" title={nav('fa-id-card-o', 'Ekyc_Ckyc Reports')}>
                    {loader && <div id="cover-spin"></div>}
                    <Reports />
                </Tab>} */}
                {/* {!hasPermission('D2C_OFFLINE') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="cibil" title={nav('fa-file-text', 'Cibil Reports')}>
                    {loader && <div id="cover-spin"></div>}
                    <CibilReports />
                </Tab>} */}
                {/* {!hasPermission('D2C_OFFLINE') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="ccmSmsEmailLogs" title={nav('fa-envelope-o', 'CCM Sms and Email Logs')}>
                    {loader && <div id="cover-spin"></div>}
                    <SMSandEMAILlogs />
                </Tab>} */}
                {/* {(user.envType==="PROD") && !hasPermission('D2C_OFFLINE') && <Tab eventKey="disableProposal" title="Disable Proposal">
                <DisableProposal />
            </Tab>} */}
                {/* {(user.envType === "UAT") && !hasPermission('D2C_OFFLINE') && <Tab eventKey="enableDisableProposal" title="Enable/Disable Proposal">
                <EnableDisableProposal />
            </Tab>} */}
                {!hasPermission('D2C_OFFLINE') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="disableEnableProposal" title={nav('fa-power-off', 'Disable/Enable Proposal')}>
                    <DisableEnableProposal />
                </Tab>}
                {!hasPermission('D2C_OFFLINE') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="productConfiguration" title={nav('fa-sliders', 'Product Configuration')}>
                    {loader && <div id="cover-spin"></div>}
                    <ProductConfig />
                </Tab>}
                {hasPermission('D2C_OFFLINE') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="D2Cpayment" title={nav('fa-money', 'D2C Offline Payment')}>
                    {loader && <div id="cover-spin"></div>}
                    <D2cPayment />
                </Tab>}
                {!hasPermission('D2C_OFFLINE') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="Insta2.0" title={nav('fa-bolt', 'Insta 2.0')}>
                    {loader && <div id="cover-spin"></div>}
                    <Insta2 />
                </Tab>}
                {!hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="InstaList" title={nav('fa-table', 'Insta View Grid')}>
                    {loader && <div id="cover-spin"></div>}
                    {/* {(window.envType === "DEV" || window.envType === "NEWGEN-UAT") ? <InstaVerifyList /> : (window.envType === "UAT" || window.envType === "NEWGEN-UAT" || window.envType === "PROD") ?<UatInstaVerifyList />:<OldInstaVerifyList />} */}
                    <InstaVerifyList />
                </Tab>}
                {!hasPermission('D2C_OFFLINE') && !hasPermission('BLUE_CHIP_USER') && !hasPermission('UPFRONT_USER') && <Tab eventKey="monthEnd" title={nav('fa-calendar-check-o', 'Month End Configuration')}>
                    {loader && <div id="cover-spin"></div>}
                    <MonthEnd />
                </Tab>}
                {hasPermission('POS') && <Tab eventKey="ftPropocess" title={nav('fa-cogs', 'FT Propocess')}>
                    {loader && <div id="cover-spin"></div>}
                    <FtProcess />
                </Tab>}
                {hasPermission('BLUE_CHIP_USER') && <Tab eventKey="blueChip" title={nav('fa-diamond', 'Blue Chip')}>
                    {loader && <div id="cover-spin"></div>}
                    <BlueChip />
                </Tab>}
                {hasPermission('BLUE_CHIP_ADMIN') && <Tab eventKey="untagged" title={nav('fa-tag', 'Untag')}>
                    {loader && <div id="cover-spin"></div>}
                    <Untagged />
                </Tab>}
                {hasPermission('UPFRONT_USER') && <Tab eventKey="upfrontPayment" title={nav('fa-credit-card', 'Upfront Payment')}>
                    {loader && <div id="cover-spin"></div>}
                    <UpfrontPayment />
                </Tab>}
                {hasPermission('UPFRONT_PAYMENT_REPORT') && !hasPermission('BLUE_CHIP_USER') &&
                    //   window.envType === "DEV" && 
                    <Tab eventKey="upfrontPaymentReport" title={nav('fa-bar-chart', 'Upfront Payment Report')}>
                        <UpfrontPaymentReport />
                    </Tab>}
                {window.envType === 'DEV' && hasPermission('SETTINGS') && <Tab eventKey="Settings" title={nav('fa-gear', 'Settings')}>
                    {loader && <div id="cover-spin"></div>}
                    <Settings setProposalTab={props.setProposalTab} />
                </Tab>
                }

            </Tabs>
        </div>
    )
}

export default SubHeader;
